// Copyright (c) 2016, Christian Liebel
// https://github.com/chliebel/angular2-click-outside
// Has since been modified by Seamgen

import { Directive, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
  selector: '[lowyClickOutside]'
})
export class ClickOutsideDirective {
  constructor(private _elementRef: ElementRef) {}

  @Output() public lowyClickOutside = new EventEmitter<MouseEvent>();

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement) {
      return;
    }

    const clickedInside = this._elementRef.nativeElement.contains(
      targetElement
    );

    if (!clickedInside) {
      this.lowyClickOutside.emit(event);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/click-outside.directive.ts